import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const MuiTopProgressLandingStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "mui-top-progress-landing",
})`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
`;
